import { axios } from '@/lib/utils/axios';

import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type DeleteDataUploadSuccessResponse = { id: string; message: string };

export async function deleteDataUpload(id: string): Promise<DeleteDataUploadSuccessResponse | null> {
	const response = await axios.delete(`${API_URLS.DATA_UPLOAD.INDEX}/${id}`);
	return getResponse<DeleteDataUploadSuccessResponse>(response.data);
}
